import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import './dashboard.css';

async function countRows(table, filter) {
  let q = supabase.from(table).select('*', { count: 'exact', head: true });
  if (filter) {
    q = filter(q);
  }
  const { count, error } = await q;
  if (error) throw error;
  return count ?? 0;
}

export default function Overview() {
  const [stats, setStats] = useState({
    businesses: null,
    conversations: null,
    leads: null,
    activeBusinesses: null,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setError('');
      setLoading(true);
      try {
        const [businesses, conversations, leads, activeBusinesses] = await Promise.all([
          countRows('businesses'),
          countRows('conversations'),
          countRows('leads'),
          countRows('businesses', (q) => q.eq('is_active', true)),
        ]);
        if (!cancelled) {
          setStats({ businesses, conversations, leads, activeBusinesses });
        }
      } catch (e) {
        if (!cancelled) {
          setError(e?.message ?? 'Failed to load stats.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const cards = [
    { label: 'Total businesses', value: stats.businesses },
    { label: 'Total conversations', value: stats.conversations },
    { label: 'Total leads', value: stats.leads },
    { label: 'Active businesses', value: stats.activeBusinesses },
  ];

  return (
    <div className="page">
      <h1 className="page-title">Overview</h1>
      {error ? <p className="page-error">{error}</p> : null}
      <div className="stat-grid">
        {cards.map(({ label, value }) => (
          <div key={label} className="stat-card">
            <div className="stat-label">{label}</div>
            <div className="stat-value">{loading ? '—' : value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
